import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import gql from 'graphql-tag';
import { client } from 'src/apollo';
import { loadUserAction } from 'src/actions/user';
import { setOperatorAction, logoutAction, verifiedTokenAction } from 'src/actions/session';

function* handleVerifyToken() {
    const { token } = yield select((state) => state.session);
    const VERIFY_TOKEN = gql`
        mutation ($token: String!) {
            verifyToken(token: $token) {
                payload
            }
        }
    `;

    const variables = {
        token
    };

    try {
        const { data } = yield client.mutate({
            mutation: VERIFY_TOKEN,
            variables
        });
        yield put(loadUserAction());
        yield put(verifiedTokenAction());

    } catch(error) {
        // A mesma action especificada no formulário. Tem como objetivo
        // desbloquear o botão submit do formulário.
        // yield put(loginFailedAction());
        console.log(error);
    }
}

function * watchVerifyToken() {
    yield takeEvery('VERIFY_TOKEN', handleVerifyToken);
}

function* handleLoadOperator() {
    const { operators } = yield select((state) => state.user.portalUser);

    if (operators.length === 0) {
        alert('Este usuário não tem relacionamento com nenhum operador.');
        // O usuário não está relacionado a nenhum operador, deve deslogar do portal.
        yield put(logoutAction());
        return;
    }

    const operatorId = sessionStorage.getItem('operatorId');

    // Verifica se o operador selecionado existe na lista.
    const hasInOperators  = operators.map((operator) => (operator.id)).includes(operatorId);
    if (operatorId && !hasInOperators) {
        yield put(logoutAction(true));
        return;
    }

    const newOperatorId = (operatorId) ? operatorId : operators[0].id;
    const reload = typeof operatorId === null;
    yield put(setOperatorAction(newOperatorId, reload));
}

function * watchLoadOperator() {
    yield takeEvery('LOAD_OPERATOR', handleLoadOperator);
}

function* handleSetOperator(action) {
    const { operatorId, reload } = action.payload;
    sessionStorage.setItem('operatorId', operatorId);

    if (reload) {
        window.location.reload();
    }
}

function * watchSetOperator() {
    yield takeEvery('SET_OPERATOR', handleSetOperator);
}

function* handleLogout() {
    sessionStorage.clear();
    window.location.reload();
}

function * watchLogout() {
    yield takeEvery('LOGOUT', handleLogout);
}

export default function* rootSessionSaga() {
    yield all([
        watchVerifyToken(),
        watchLoadOperator(),
        watchSetOperator(),
        watchLogout()
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/session.js